<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Many thanks to those who helped me in a technical capacity to complete this work, namely Paul and Cheryl Roberts, Denis Bartley and John Conway. Your practical advice has been invaluable.</p><br/>
<p style="text-indent:0em;">Also, many thanks to my good friend, Yorkshire Paul, for encouraging me to share this story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0af0260f